import PropTypes from "prop-types";
import React from "react";
import { badgeClassForToken } from "./courtedConstants";

export const BooleanBadge = ({ value, field }) => {
  if (value == null) {
    return null;
  }
  const isYes = Boolean(value);
  const token = isYes
    ? field.badgeToken
    : field.badgeTokenNo || field.badgeToken;
  return (
    <span className={badgeClassForToken(token)}>{isYes ? "Yes" : "No"}</span>
  );
};

BooleanBadge.propTypes = {
  value: PropTypes.bool,
  field: PropTypes.shape({
    badgeToken: PropTypes.string.isRequired,
    badgeTokenNo: PropTypes.string,
  }).isRequired,
};

export default BooleanBadge;
